import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// This component is designed to be used once per app
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
